module.exports = __webpack_public_path__ + "3fcf4ddcde585932be47f08eda27f93d.MP3";